import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { CustomProvider } from 'rsuite'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store/store'
import { Loader } from './shared'
import { applyTenantTheme } from './config/tenant/applyTheme'
import suppressResizeObserverLoopError from './utils/suppressResizeObserverLoopError'
import './scss/app.scss'

suppressResizeObserverLoopError()

applyTenantTheme()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Suspense fallback={<Loader />}>
    <CustomProvider theme="light">
      <Provider store={store}>
        <App />
      </Provider>
    </CustomProvider>
  </Suspense>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
